// Calendly integration utility
declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (options: {
        url: string
        prefill?: Record<string, string>
        utm?: Record<string, string>
      }) => void
      closePopupWidget: () => void
    }
  }
}

export function openCalendlyPopup() {
  if (typeof window !== 'undefined' && window.Calendly) {
    window.Calendly.initPopupWidget({
      url: 'https://calendly.com/justus-kraft/crm-automatisierung-demo-website?hide_gdpr_banner=1&primary_color=ff5722&background_color=0a0e27&text_color=ffffff',
    })
  } else {
    // Fallback: open in new tab if Calendly script hasn't loaded
    window.open(
      'https://calendly.com/justus-kraft/crm-automatisierung-demo-website?hide_gdpr_banner=1&primary_color=ff5722&background_color=0a0e27&text_color=ffffff',
      '_blank',
    )
  }
}

export function loadCalendlyScript() {
  if (typeof window === 'undefined') return

  // Check if script already exists
  if (document.querySelector('script[src*="calendly.com"]')) return

  // Load Calendly CSS
  const link = document.createElement('link')
  link.href = 'https://assets.calendly.com/assets/external/widget.css'
  link.rel = 'stylesheet'
  document.head.appendChild(link)

  // Load Calendly JS
  const script = document.createElement('script')
  script.src = 'https://assets.calendly.com/assets/external/widget.js'
  script.async = true
  document.head.appendChild(script)
}
